export const getAttributionChannel = () => {
  if (typeof window === "undefined") return "";
  const queryChannel = new URLSearchParams(window.location.search).get("c");
  const pathChannel = window.location.pathname.startsWith("/c/") ? window.location.pathname.substring(3) : "";
  if (queryChannel || pathChannel) return queryChannel || pathChannel;
  try {
    const persisted = JSON.parse(localStorage.getItem("persist") || "{}");
    return (persisted && persisted.channel) || "";
  } catch (error) {
    return "";
  }
};

export const shouldSkipPPRegistration = (event, data = {}) => {
  const name = String(event || "").trim().toLowerCase();
  if (name !== "register" && name !== "register2") return false;
  if (getAttributionChannel() !== "pp") return false;
  // PP 按注册转化计费，仅回传手机注册，排除邮箱和游客。
  return name === "register2" || String((data && data.method) || "").trim().toLowerCase() === "email";
};
